import { __rest } from "tslib";
import * as React from 'react';
import { sanitizeHtml } from '@shared/lib';
const SafeHtml = React.forwardRef((_a, ref) => {
    var { html, tag = 'div', className, sanitizeConfig } = _a, rest = __rest(_a, ["html", "tag", "className", "sanitizeConfig"]);
    const clean = React.useMemo(() => sanitizeHtml(html, sanitizeConfig), [html, sanitizeConfig]);
    return React.createElement(tag, Object.assign(Object.assign({ 'data-sanitized-html': true }, rest), { ref,
        className, dangerouslySetInnerHTML: { __html: clean } }));
});
SafeHtml.displayName = 'SafeHtml';
export default SafeHtml;
